import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "../types/answer";
import { Count, CountDTO } from "./count";

export interface GridMultiSelectResultV1DTO {
  answer: AnswerDTO;
  count: CountDTO;
}

export class GridMultiSelectResultV1 {
  readonly isGridMultiSelectResultV1GridMultiSelectResultV1: boolean = true;

  readonly answer: Answer;
  readonly count: Count;


  constructor(
  answer: Answer, 
  count: Count
  ) {
    this.answer = answer;
    this.count = count;
  }

  static fromDTO(dto: GridMultiSelectResultV1DTO): GridMultiSelectResultV1 {
    const answer = Answer.fromDTO(getObject(dto, "answer", InvalidGridMultiSelectResultV1AnswerError));
    const count = Count.fromDTO(getObject(dto, "count", InvalidGridMultiSelectResultV1CountError));
    return new GridMultiSelectResultV1(
      answer,
      count
    );
  }

  toDTO(): GridMultiSelectResultV1DTO {
    const dto: GridMultiSelectResultV1DTO = {
        answer: this.answer.toDTO(),
        count: this.count.toDTO()
    };
    return dto;
  }
  }

GridMultiSelectResultV1.prototype.toString = function toString(): string {
  return `GridMultiSelectResultV1(answer='${this.answer}',count='${this.count}')`;
};

export class InvalidGridMultiSelectResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectResultV1Error";
  }
}
export class InvalidGridMultiSelectResultV1AnswerError extends InvalidGridMultiSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectResultV1AnswerError";
  }
}

export class InvalidGridMultiSelectResultV1CountError extends InvalidGridMultiSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiSelectResultV1CountError";
  }
}
